import React, { FC, useState } from 'react';
import { Link } from 'react-router-dom';
import { PRIVATEPATHS } from '@core/enums/paths.enum';

const As2TestingGuide: FC = () => {
    const [open, setOpen] = useState(false);

    return (
        <div className="rounded-md border border-slate-200 bg-slate-50">
            <button
                type="button"
                onClick={() => setOpen((v) => !v)}
                className="flex w-full items-center justify-between px-4 py-2.5 text-left text-sm font-semibold text-slate-700 hover:bg-slate-100"
            >
                <span>Pre-go-live AS2 checklist</span>
                <span className="text-slate-400">{open ? '▲' : '▼'}</span>
            </button>
            {open && (
                <div className="border-t border-slate-200 px-4 py-3 text-xs text-slate-700">
                    <p className="mb-3 text-slate-600">
                        Each trading partner has a production row and a pre-go-live{' '}
                        <code className="font-mono">{'{GROUP}_TEST'}</code> row. Complete these steps before
                        enabling the production partner for live shipments.
                    </p>
                    <ol className="list-decimal space-y-1.5 pl-4">
                        <li>
                            <Link to={PRIVATEPATHS.Integrations} className="text-[#bd902e] hover:underline">
                                Setup &amp; health
                            </Link>{' '}
                            → <strong>Add partner</strong> → enter AS2 IDs, URLs, and upload the partner certificate.
                        </li>
                        <li>
                            <Link to={PRIVATEPATHS.As2Partners} className="text-[#bd902e] hover:underline">
                                Partners
                            </Link>{' '}
                            → <strong>Test URL</strong> on <code className="font-mono">{'{GROUP}_TEST'}</code>{' '}
                            (reachability to the partner receive endpoint).
                        </li>
                        <li>
                            <Link to={PRIVATEPATHS.As2Messages} className="text-[#bd902e] hover:underline">
                                Messages
                            </Link>{' '}
                            or wizard step Verify → <strong>Send test EPCIS</strong> to{' '}
                            <code className="font-mono">{'{GROUP}_TEST'}</code>.
                        </li>
                        <li>
                            Filter by <code className="font-mono">{'{GROUP}_TEST'}</code> → expect{' '}
                            <strong>MDN Received</strong> with disposition <strong>Processed</strong> within ~30s.
                        </li>
                        <li>
                            Email the partner your production inbound details (Antar AS2 ID, inbound URL, public
                            certificate), then enable the production row <code className="font-mono">{'{GROUP}'}</code>.
                        </li>
                        <li>
                            Send one production dispatch → confirm <strong>MDN Received</strong> before routine
                            auto-send on ship.
                        </li>
                    </ol>
                </div>
            )}
        </div>
    );
};

export default As2TestingGuide;
